const { Breakpoints } = require("../../breakpoints");

export default class SwiperInstances {
  constructor() {
    this.el = "slider";
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      document
        .querySelectorAll(`.${this.el}__gallery`)
        .forEach((swiperEl) => {
          if (!!swiperEl.initialized) return;

          const swiperParams = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            // spaceBetween: 40,
            loop: false,
            autoHeight: true,
            // centerInsufficientSlides: true,
            // breakpoints: {
            //   [Breakpoints.sm]: {
            //     slidesPerView: 2,
            //   },
            //   [Breakpoints.md]: {
            //     slidesPerView: 3,
            //   },
            //   [Breakpoints.xl]: {
            //     slidesPerView: 4,
            //   },
            // },
            navigation: {
              clickable: true,
              disabledClass: "!opacity-50 !pointer-events-none",
              nextEl: swiperEl
                .closest(`.${this.el}`)
                ?.querySelector(`.${this.el}__gallery-next`),
              prevEl: swiperEl
                .closest(`.${this.el}`)
                ?.querySelector(`.${this.el}__gallery-prev`),
            },
          };

          // now we need to assign all parameters to Swiper element
          Object.assign(swiperEl, swiperParams);

          // and now initialize it
          swiperEl.initialize();
        });
    });
  }
};
